'use strict';
import * as $ from 'jquery';
import Slideout from '../../node_modules/slideout/dist/slideout';

//ローディング
if (document.getElementById('top') == null) {
    $(window).on('load', function () {
        setTimeout(function () {
            $('#loading').fadeOut('slow');
        }, 500)
    });
}

//ヘッダー高さ設定
const headerfixY:number = 100;
const headerAddClass: string = 'is_move';
window.addEventListener("scroll", () => {
    let py: number = window.scrollY || window.pageYOffset;
    if (headerfixY < py) {
        $('#globalHeader').addClass(headerAddClass);
    }
    else{
        $('#globalHeader').removeClass(headerAddClass);
    }
})

//スマホメニュー設定
let slideout = new Slideout({
    'panel': document.getElementById('wrapper'),
    'menu': document.getElementById('menuSp'),
    'padding': 200,
    'tolerance': 70,
    'side': 'right',
    'touch': false
});

/**
 *  pagetop：ページトップボタン表示・非表示
 *  @param  {string}：要素 
 *  @return {void}
 */
let pagetop = function (_ele:string) {
    let showFlag:boolean = false;
    let topBtn:any = $(_ele);
    const pos:number = 200;//スクロール位置
    topBtn.css('bottom', '-100px');
    window.addEventListener("scroll", () => {
        let wt:number = window.pageYOffset;
        if(wt > pos) {
            if (showFlag == false) {
                showFlag = true;
                topBtn.stop().animate({ 'bottom': '20px' }, 300);
            }
        } else{
            if (showFlag) {
                showFlag = false;
                topBtn.stop().animate({ 'bottom': '-100px' }, 300);
            }
        }
    });
    topBtn.find('a').on('click',function(){
        $('body,html').animate({ scrollTop: 0 }, 600, 'swing');
        return false;
    });
}


document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('menuSpButton').addEventListener('click', function (ev) {
        ev.preventDefault();
        this.classList.toggle('active');
        document.getElementById('globalHeaderLogo').classList.toggle('active');        
        slideout.toggle();
    });

    pagetop('#pagetop');
});

